import React from "react";
import { CircularProgress, Backdrop, Typography } from "@mui/material";

export function Loading({ text = "Cargando" }) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={true}
    >
      <div style={{ textAlign: "center" }}>
        <CircularProgress color="inherit" />
        <Typography variant="h6" sx={{ mt: 2 }}>
          {text}
        </Typography>
      </div>
    </Backdrop>
  );
}
